import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { PermissionDispatch } from '../modal';

export default function reducer(state: PermissionDispatch = new PermissionDispatch(),
  action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.PERMISSION_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.PERMISSION_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.PERMISSION_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
